<template>
  <div class="header flex-row">
    <img class="logo" src="@/assets/images/common/logo.svg" alt="" />
    <div class="header-title-list flex-row">
      <div class="header-title" @click="jump('首页', '/')" :class="headCurrent == '首页' ? 'header-active' : ''">
        首页
      </div>
      <span class="split-line"></span>
      <div class="header-title" @click="jump('关于我们', '/aboutus')" :class="headCurrent == '关于我们' ? 'header-active' : ''">
        关于我们
      </div>
      <span class="split-line"></span>
      <div class="header-title" @mouseover="subTitleShow = true" @mouseout="subTitleShow = false" :class="headCurrent == '业务生态' ? 'header-active'
          : ''
        ">
        业务生态
        <div class="subtitle flex-row" :style="subTitleShow ? 'opacity:1' : 'opacity:0;visibility:hidden'"
          @mouseout="subTitleShow = false">
          <div class="container flex-row subtitle-list">
            <div class="flex-row" @click="jump('业务生态', '/capital')">
              <img src="@/assets/images/common/ecology6.png" alt="" />产业投资
            </div>
            <div class="flex-row" @click="jump('业务生态', '/invest',)">
              <img src="@/assets/images/common/ecology1.png" alt="" />产业精准招商
            </div>
            <div class="flex-row" @click="jump('业务生态', '/plan')">
              <img src="@/assets/images/common/ecology2.png" alt="" />产业赋能服务
            </div>
            <div class="flex-row" @click="jump('业务生态', '/analysis')">
              <img src="@/assets/images/common/ecology3.png" alt="" />产业数据分析
            </div>
            <div class="flex-row" @click="jump('业务生态', '/train')">
              <img src="@/assets/images/common/ecology4.png" alt="" />产业人才培训
            </div>

            <!-- <div
              class="flex-row"
              @click="jump('业务生态', '/layout')"
            >
              <img
                src="@/assets/images/common/ecology5.png"
                alt=""
              />产业项目布局
            </div> -->

          </div>
        </div>
      </div>
      <span class="split-line"></span>
      <div class="header-title" @click="jump('全流程服务', '/service')"
        :class="headCurrent == '全流程服务' ? 'header-active' : ''">
        全流程服务
      </div>
      <span class="split-line"></span>
      <div class="header-title" @click="jump('中产资讯', '/news')" :class="headCurrent == '中产资讯' ? 'header-active' : ''">
        中产资讯
      </div>
      <span class="split-line"></span>
      <div class="header-title" @click="jump('联系我们', '/contactUs')"
        :class="headCurrent == '联系我们' ? 'header-active' : ''">
        联系我们
      </div>
      <span class="split-line"></span>
      <div class="header-title" @click="jump('CEBC', '/cebc')"
        :class="headCurrent == 'CEBC' ? 'header-active' : ''">
        CEBC
      </div>
    </div>

    <!-- <div class="search-bar flex-row"><input type="text" placeholder="请输入关键词"><img class="search-icon" src="@/assets/images/common/search-icon.png" alt=""></div> -->
    <div>
      <img class="phone" src="@/assets/images/common/phone.png" alt="" />
      400-820-3779
    </div>
  </div>
</template>

<script>
import "@/assets/css/header.css";
export default {
  name: "Header",
  data() {
    return {
      headCurrent: "首页",
      subTitleShow: false
    };
  },
  created() {
    this.headCurrent = sessionStorage.getItem('headCurrent') ? sessionStorage.getItem('headCurrent') : '首页'
  },
  methods: {
    jump(name, path) {
      this.headCurrent = name;
      sessionStorage.setItem("headCurrent", name);
      if (path != '/' && location.pathname.indexOf(path) != -1 && location.pathname != '/newsdetail') return//防止首页和资讯详情
      this.$router.push({ path: path });
    },
    openPdf() {
      window.open("https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/%E6%97%A5%E6%9C%ACCEBC%E5%85%AC%E5%8F%B8%E4%BB%8B%E7%BB%8D%EF%BC%88%E4%B8%AD%E6%96%87%EF%BC%89.pdf",'_blank');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue